import { Observable, map } from "rxjs";
import { ITokenPair } from "../../../features/auth/interface/dto/token-pair";
import { get } from "../../../service/api";
import { IAnnouncementDto } from "../interface/dto/announcements.dto";

export const getAnnouncements = (
    tokens: ITokenPair,
): Observable<Array<string>> =>
    get<Array<IAnnouncementDto>>(
        "/content/announcements",
        undefined,
        tokens,
    ).pipe(map((response) => response.map(({ content }) => content)));
